import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import { topics, socials } from './config';
import { allPosts } from '../../posts';

const BlogFooter = () => {
  return (
    <footer className="blog__footer">
      <div className="container blog__footer-grid">
        {/* Brand block */}
        <div className="blog__footer-brand">
          <Link to="/blog" className="blog__footer-wordmark">
            jonahodoh.dev
          </Link>
          <p>
            An engineering blog by <strong>Jonah Odoh</strong>. Notes on backend
            systems, platform reliability, and shipping AI into production. New
            posts whenever the work earns one.
          </p>
          <div className="blog__footer-badge">
            <span className="blog__footer-badge-dot" />
            ENGINEERING · {new Date().getFullYear()}
          </div>
        </div>

        {/* Topics */}
        <div className="blog__footer-col">
          <h4>Topics</h4>
          {topics.map((t) => (
            <Link key={t.slug} to={`/blog/topic/${t.slug}`}>
              {t.name}
            </Link>
          ))}
        </div>

        {/* Site */}
        <div className="blog__footer-col">
          <h4>Site</h4>
          <Link to="/blog">All posts</Link>
          <Link to="/">Portfolio</Link>
          <Link to="/#contact">Contact</Link>
        </div>

        {/* Elsewhere */}
        <div className="blog__footer-col">
          <h4>Elsewhere</h4>
          <a href={socials.linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn <FiArrowUpRight />
          </a>
          <a href={socials.twitter} target="_blank" rel="noopener noreferrer">
            X / Twitter <FiArrowUpRight />
          </a>
          <a href={socials.email}>
            Email <FiArrowUpRight />
          </a>
        </div>
      </div>

      <div className="container blog__footer-bottom">
        <span>© {new Date().getFullYear()} Jonah Odoh.</span>
        <span>VOL. I · {String(allPosts.length).padStart(2, '0')} POSTS</span>
      </div>
    </footer>
  );
};

export default BlogFooter;
